export default __webpack_public_path__ + "static/media/bet2.27c29011.png";